export function formatDate(dateStr) {
    const date = new Date(dateStr);
    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
}



